import React from "react"
import { FlexRow, FlexCol } from "components/FlexGrid"
import InternalNav from "../InternalNav/InternalNav"
import { ContactForm } from "components/ContactForm"
import {
  InternalFlexGrid,
  RightColumnContainer,
} from "components/InternalPage/style"
import { ContactPageContainer } from "./style"
import { InternalRHSCTA } from "components/InternalRHSCTA"
const ContactPage = () => {
  return (
    <ContactPageContainer>
      <InternalFlexGrid fullWidth gap={[0, 0, 20, 40]} rowGap={[0]}>
        <FlexRow>
          <FlexCol xs={12} md={8}>
            <ContactForm />
          </FlexCol>
          <FlexCol xs={12} md={4}>
            <RightColumnContainer>
              <InternalNav page={2} />
              <InternalRHSCTA/>
            </RightColumnContainer>
          </FlexCol>
        </FlexRow>
      </InternalFlexGrid>
    </ContactPageContainer>
  )
}

export default ContactPage
